/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  VzzYJk: 'Create',
  'platform.navigation-experiences.universal-create.show-less': 'Less',
  'platform.navigation-experiences.universal-create.show-more': 'More',
};
